import React from "react";
import LanguageContainer from "./LanguagesContainer";
import MediaContainer from "./MediaContainer";
import ThemeContainer from "./ThemeContainer";

const NavbarAccessoriesList = () => {
    return (
        <ul className="navbar-accessories-list">
            <LanguageContainer />
            <ThemeContainer />
            <MediaContainer />
        </ul>
    );
};

export default NavbarAccessoriesList;
